module.exports = __webpack_public_path__ + "static/media/nat-2-large.7a25f199.jpg";